import * as React from 'react';
import _ from 'lodash';

import { core, safeEnumCompare, toEnumString } from '@tock/coretypes';
import BaseComponent from '@tock/shared/components/BaseComponent';
import Field from '@tock/shared/components/forms/Field';
import RadioButtons from '@tock/shared/components/inputs/RadioButtons';
import protos from 'utils/protos';

const { EmailPolicy } = protos;

export const NO_RESTRICTIONS: core.EmailPolicy = {
  type: toEnumString(EmailPolicy.Type, EmailPolicy.Type.NO_RESTRICTIONS) as core.EmailPolicy.Type,
};

export const SKIP_GUEST: core.EmailPolicy = {
  type: toEnumString(EmailPolicy.Type, EmailPolicy.Type.SKIP_GUEST) as core.EmailPolicy.Type,
};

interface Props {
  label: string;
  emailPolicy: core.EmailPolicy;
  onEmailPolicyChange(emailPolicy: core.IEmailPolicy): void;
}

/**
 * @deprecated
 * Use new components utilizing material UI base components instead.
 */
export default class EmailPolicyChoice extends BaseComponent<Props> {
  handleChangePolicy(event: React.SyntheticEvent<HTMLInputElement>) {
    const newPolicy = safeEnumCompare(
      event.currentTarget.value,
      EmailPolicy.Type,
      EmailPolicy.Type.SKIP_GUEST
    )
      ? SKIP_GUEST
      : NO_RESTRICTIONS;
    this.props.onEmailPolicyChange(newPolicy);
  }

  render() {
    const { emailPolicy, label } = this.props;

    const options = [
      {
        value: NO_RESTRICTIONS.type,
        key: 'yes',
        label: 'Yes',
      },
      {
        value: SKIP_GUEST.type,
        key: 'no',
        label: 'No',
      },
    ];

    return (
      <div className="EmailPolicy">
        <Field label={label}>
          <RadioButtons
            field={{
              value: emailPolicy.type || NO_RESTRICTIONS.type,
              onChange: _.noop,
              onBlur: _.noop,
            }}
            options={options}
            onChange={this.handleChangePolicy}
          />
        </Field>
      </div>
    );
  }
}
